"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Drawer = _interopRequireDefault(require("@mui/material/Drawer"));
var _globalSpacing = require("./../globalSpacing");
var _styles = require("../styles");
var _tokens = require("../styles/tokens");
var _excluded = ["classes", "spacingOptions", "anchor", "fullScreen"],
  _excluded2 = ["fullScreenDrawer", "fullScreenPaper"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = function styles(theme) {
  var _root;
  return {
    root: (_root = {
      width: '17rem'
    }, _root[theme.breakpoints.up('sm')] = {
      width: '25.9375rem' // 415px
    }, _root),
    fullScreenDrawer: {
      width: '100%',
      height: '100%'
    },
    fullScreenPaper: {
      height: 'inherit'
    },
    paper: {
      width: 'inherit',
      gridAutoRows: 'minmax(min-content, max-content)'
    },
    docked: {},
    paperAnchorLeft: {},
    paperAnchorRight: {},
    paperAnchorTop: {},
    paperAnchorBottom: {},
    paperAnchorDockedLeft: {},
    paperAnchorDockedRight: {},
    paperAnchorDockedTop: {},
    paperAnchorDockedBottom: {},
    modal: {}
  };
};

/**
 * A component that can be used for navigation or to provide supplemental information.
 * @done true
 * @updated v7.0.0
 * @versionAdded v3.14.0
 * @examples
 *  TemporaryDrawer
 *  ResponsiveDrawer
 *  FullScreenDrawer
 *  DrawerWithCustomSpacing
 *  DrawerWithCustomSpacingSpacingOptions
 */
var Drawer = function Drawer(props) {
  var _classNames, _classNames2;
  var classes = props.classes,
    spacingOptionsLocal = props.spacingOptions,
    anchor = props.anchor,
    fullScreen = props.fullScreen,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var _useSpacing = (0, _globalSpacing.useSpacing)(spacingOptionsLocal),
    spacingStyles = _useSpacing[0],
    setSpacingOptions = _useSpacing[2];
  var fullScreenDrawer = classes.fullScreenDrawer,
    fullScreenPaper = classes.fullScreenPaper,
    restClasses = (0, _objectWithoutPropertiesLoose2.default)(classes, _excluded2);
  var classOverrides = (0, _extends2.default)({}, restClasses, {
    root: (0, _classnames.default)((_classNames = {}, _classNames[classes.root] = anchor === 'left' || anchor === 'right', _classNames[fullScreenDrawer] = fullScreen, _classNames)),
    paper: (0, _classnames.default)(classes.paper, spacingStyles, (_classNames2 = {}, _classNames2[fullScreenPaper] = fullScreen, _classNames2))
  });
  (0, _react.useEffect)(function () {
    setSpacingOptions(spacingOptionsLocal);
  }, [spacingOptionsLocal]); // eslint-disable-line

  return /*#__PURE__*/_react.default.createElement(_Drawer.default, (0, _extends2.default)({
    classes: classOverrides,
    anchor: anchor
  }, rest));
};
Drawer.muiName = 'Drawer';
Drawer.propTypes = {
  /**
   * Side from which the drawer will appear.
   */
  anchor: _propTypes.default.oneOf(['bottom', 'left', 'right', 'top']),
  /**
   * The contents of the drawer.
   */
  children: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component. See Classes API below for more details.
   */
  classes: _propTypes.default.object,
  /**
   * The elevation of the drawer.
   */
  elevation: _propTypes.default.number,
  /**
   * Props applied to the [`Modal`](https://material-ui.com/api/modal/) element.
   *
   * Only available when the variant is "temporary"
   */
  ModalProps: _propTypes.default.object,
  /**
   * Callback fired when the component requests to be closed.
   * Signature: `function(event: object) => void`
   * event: The event source of the callback.
   */
  onClose: _propTypes.default.func,
  /**
   * If true, the drawer is open.
   */
  open: _propTypes.default.bool,
  /**
   * Props applied to the [`Paper`](#/components/Paper) element.
   */
  PaperProps: _propTypes.default.object,
  /**
   * Props applied to the [`Slide`](https://material-ui.com/api/slide/) element.
   */
  SlideProps: _propTypes.default.object,
  /**
   * The duration for the transition, in milliseconds. You may specify a single timeout for all transitions, or individually with an object.
   *
   * Object format: { appear?: number, enter?: number, exit?: number }
   *
   * Default value: `{enter: duration.enteringScreen, exit: duration.leavingScreen}`
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object]),
  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary']),
  /**
   * If `true`, the Drawer will be full-screen
   */
  fullScreen: _propTypes.default.bool,
  /**
   * Provides several attributes to control `Drawer` spacing.
   *
   * Available options are:
   *
   * * `spacing` (string): **'standard'** | 'none' | \<object\>
   *      * Controls the padding of the `Drawer` and grid gap between child elements
   *      * `standard`: The default spacing
   *      * `none`: Removes all spacing styles, allowing for complete style customization through the `classes` prop
   *      * `object`: Allows for more fine-grained spacing customization. See [container customization documentation](#/utilities/spacing#using-customizations-for-fine-grained-container-spacing-control)
   *        for more details.
   * * `outerSpacing` (bool): **true** | false
   *      * If set to `false`, removes the drawer's outer padding (but retains the space between its subcomponents)
   */
  spacingOptions: _propTypes.default.shape({
    spacing: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
    outerSpacing: _propTypes.default.bool
  }),
  /**
  * The system prop that allows defining system overrides as well as additional CSS styles.
  */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};

// If default props are needed, they must be set here
Drawer.defaultProps = {
  anchor: 'left',
  elevation: 16,
  ModalProps: {},
  open: false,
  PaperProps: {},
  SlideProps: {},
  variant: 'temporary',
  fullScreen: false,
  spacingOptions: {
    spacing: {
      xs: {
        padding: _tokens.spacing40,
        gutter: _tokens.spacing40
      },
      lg: {
        padding: _tokens.spacing60,
        gutter: _tokens.spacing50
      }
    }
  }
};
var _default = exports.default = (0, _styles.withStyles)(styles)(Drawer);